import {SxType} from "@baseTypes/sx/sxTypes";

export const sx:SxType = {
    root: {
        padding: '8px'
    },
}